import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-179164a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "login"
}
const _hoisted_2 = { class: "login bg-green-600 min-h-screen pt-12 md:pt-20 pb-6 px-2 md:px-0" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", { class: "max-w-lg mx-auto" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#!" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl font-bold text-white text-center" }, [
      /*#__PURE__*/_createElementVNode("img", {
        class: "m-auto",
        src: _imports_0,
        width: "120",
        alt: "logo l'angolo della frutta"
      })
    ])
  ])
], -1))
const _hoisted_4 = { class: "bg-white max-w-lg mx-auto p-8 md:p-12 my-10 rounded-lg shadow-2xl" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", null, [
  /*#__PURE__*/_createElementVNode("h3", { class: "font-bold text-2xl" }, "Autenticazione"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-gray-600 pt-2 text-sm" }, "Per poter utilizare l'applicazione inserisci un numero di cellulare autorizzato.")
], -1))
const _hoisted_6 = { class: "mt-10" }
const _hoisted_7 = { class: "flex flex-col" }
const _hoisted_8 = { class: "mb-6 pt-3 rounded bg-gray-200" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "block text-gray-700 text-sm font-bold mb-2 ml-3",
  for: "phone-number"
}, "Telefono", -1))
const _hoisted_10 = {
  key: 0,
  class: "animate-spin -ml-1 mr-3 h-5 w-5 text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  class: "opacity-25",
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  "stroke-width": "4"
}, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  class: "opacity-75",
  fill: "currentColor",
  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
}, null, -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Autenticati ")
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "max-w-lg mx-auto text-center mt-12 mb-6" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-white" }, [
    /*#__PURE__*/_createTextVNode("Non hai ancora un'autorizzazione o hai difficoltà con l'accesso? "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      class: "font-bold hover:underline"
    }, "Contattaci"),
    /*#__PURE__*/_createTextVNode(".")
  ])
], -1))
const _hoisted_16 = {
  id: "authcode-modal",
  class: "modal opacity-0 pointer-events-none fixed w-full h-full top-0 left-0 flex items-center justify-center z-20"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-overlay absolute w-full h-full bg-gray-900 opacity-60" }, null, -1))
const _hoisted_18 = { class: "modal-container bg-white w-11/12 md:max-w-md mx-auto rounded shadow-lg z-50 overflow-y-auto" }
const _hoisted_19 = { class: "modal-content py-4 text-left px-6" }
const _hoisted_20 = { class: "flex justify-between items-center pb-3" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-2xl font-bold" }, "Codice autenticazione", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "fill-current text-black",
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 18 18"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z" })
], -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm mb-7" }, "Inserisci il codice di autenticazione che ti è arrivato via SMS.", -1))
const _hoisted_25 = { class: "mt-10" }
const _hoisted_26 = { class: "flex flex-col" }
const _hoisted_27 = { class: "mb-6 pt-3 rounded bg-gray-200" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "block text-gray-700 text-sm font-bold mb-2 ml-3",
  for: "authcode"
}, "Codice", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.authIsReady && !_ctx.user)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("main", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("section", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _withDirectives(_createElementVNode("input", {
                    type: "tel",
                    id: "phone-number",
                    class: "bg-gray-200 rounded w-full text-gray-700 focus:outline-none border-b-4 border-gray-300 focus:border-purple-600 transition duration-500 px-3 pb-3",
                    placeholder: "+393xxxxxxxxx",
                    pattern: "(([+]|00)39)?((3[1-6][0-9]))(\\d{7})",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.phoneNumber) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.phoneNumber]
                  ])
                ]),
                _createElementVNode("button", {
                  class: _normalizeClass(["inline-flex justify-center bg-green-600 hover:bg-green-700 text-white font-bold py-2 rounded shadow-lg hover:shadow-xl transition duration-200", { 'opacity-60 cursor-not-allowed': !_ctx.isPhoneNumOk || _ctx.sendingOtp }]),
                  type: "button",
                  id: "sign-in-button",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isPhoneNumOk && _ctx.sendOtp()))
                }, [
                  (_ctx.sendingOtp)
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_10, _hoisted_13))
                    : _createCommentVNode("", true),
                  _hoisted_14
                ], 2)
              ])
            ])
          ]),
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _createElementVNode("div", {
                    class: "modal-close cursor-pointer z-50",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleModal()))
                  }, _hoisted_23)
                ]),
                _hoisted_24,
                _createElementVNode("section", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _hoisted_28,
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        id: "authcode",
                        class: "bg-gray-200 rounded w-full text-gray-700 focus:outline-none border-b-4 border-gray-300 focus:border-purple-600 transition duration-500 px-3 pb-3",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.authcode) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.authcode]
                      ])
                    ]),
                    _createElementVNode("button", {
                      class: "bg-green-600 hover:bg-green-700 text-white text-center font-bold py-2 rounded shadow-lg hover:shadow-xl transition duration-200",
                      type: "button",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.confirm()))
                    }, "Invia")
                  ])
                ])
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}